import React from "react";
import { useNavigate } from "react-router-dom";

import { ModalContext } from "../../components/modal/modal";
import { StorageContext } from "../../components/storage/storage-context";
import { EventPerformance } from "../../models/models";
import SCRUD from "../../components/utilities/SCRUD/SCRUD";
import EventSCRUDRender from "../../components/event/event.scrud.render";
import EventSCRUDForm from "../../components/event/event.scrud.form";

import EventsService from "../../services/event.service";
import { timeData } from "../../models/models";


const { periods, weekdays, months, daysPerMonth, years, dates, times } = timeData;

const acceptedMedia = [
  'gif', 'jpg', 'jpeg', 'png',
  'mov', 'mp4', 'mpeg', 'webm', 'ogg'
];

type FormEvent = Omit<EventPerformance, "month" | "day" | "year" | "time" | "period"> & { 
  day: "Day" | EventPerformance["day"],
  month: "Month" | EventPerformance["month"],
  year: "Year" | EventPerformance["year"],
  time: "Time" | EventPerformance["time"],
  period: "Period" | EventPerformance["period"]
}

const AdminEvents: React.FC<any> = (props: any) => {

  const modalContext = React.useContext(ModalContext);
  const [storageContext, setStorageContext] = React.useContext(StorageContext);
  const navigate = useNavigate();

  const [media, setMedia] = React.useState<string[]>([]);
  const [events, setEvents] = React.useState<EventPerformance[]>([]);

  React.useEffect(() => {
    // Check if the user is authenticated
    // make sure storageContext is resolved first
    Promise.resolve(storageContext).then((storageContextResolved) => {
      if (!storageContextResolved.token) {
        navigate('/login');
      }
    });
  }, []);

  React.useEffect(() => {
    // is the timing of this gauranteed?
    EventsService.resetEvents();
  }, [events])

  return (
    <div className="py-16 px-1 md:px-4 mx-auto diamonds">

      <div className="flex items-center justify-between">
        <h1 className="text-xl gold-text text-center inline-block ml-2 md:ml-8">
          &nbsp;&nbsp;Admin Events&nbsp;&nbsp;
        </h1>
        <div className="">
          <button 
            className="btn btn-circle btn-lg ml-auto border border-white mr-2 md:mr-8"
            onClick={() => navigate('/admin')}
          >
            Close
          </button>
        </div>
      </div>

      <div className="p-1 md:p-8 md:m-8 py-8 my-8 bg-gradient-to-br from-pink-200 via-pink-300 to-pink-200 rounded-lg">

        <SCRUD<EventPerformance>
          Components={{
            ModelRender: EventSCRUDRender,
            ModelForm: EventSCRUDForm
          }}
          css={{
            searchbar: "px-4 rounded-l-lg rounded-r-none",
            newbutton: "rounded-r-lg rounded-l-none bg-slate-600 hover:bg-slate-500 border border-slate-400",
          }}
          routes={{
            stream: {
              routeName: "eventstream",
              params: (events: EventPerformance[]) => ({
                afterID: events[events.length - 1]?.id || 9999999,
              })
            },
            create: {
              routeName: "eventcreate",
              params: (newEvent: Partial<EventPerformance>) => ({...newEvent})
            },
            update: {
              routeName: "eventupdate",
              params: (updatedEvent: Partial<EventPerformance>) => ({ id: updatedEvent.id, update: {...updatedEvent}})
            },
            delete: {
              routeName: "eventdelete",
              params: (eventToDelete: Partial<EventPerformance>) => ({ id: eventToDelete.id })
            }
          }} 
          content={events}
          setContent={setEvents} 
          newDummyElement={{
            id: 0,
            timestamp: new Date().getTime(),
            day: 1, //dates[(new Date().getDate())],
            month: months[(new Date().getMonth())],
            year: new Date().getFullYear(),
            period: 'Once',
            time: '12:00am',
            location: '',
            addressa: '',
            addressb: '',
            description: '',
            thumbnail: '',
            website: '',
            media: []
          }}        
        /> 
      </div>

    </div>
  )
}

export default AdminEvents;